export default class PayStrategy {
  constructor() {
    this.amount = 0;
    this.fixedFee = 0;
    this.feePercentage = 0;
    this.threshold = 0;
    this.percentageFeeAboveThreshold = 0;
    this.isClientPaysFeeNull = false;
  }

  calculateTotal() {
    throw new Error("Strategy#calculateTotal needs to be overridden.");
  }

  calculateFee() {
    throw new Error("Strategy#calculateFee needs to be overridden.");
  }

  setAmount(amount) {
    this.amount = amount;
  }

  setClientPaysFeeNull(value) {
    this.isClientPaysFeeNull = value;
  }

  setFeePercentage(feePercentage) {
    this.feePercentage = feePercentage / 10000;
  }

  setFixedFee(fixedFee) {
    this.fixedFee = fixedFee * 100;
  }

  setThreshold(threshold) {
    this.threshold = threshold * 100;
  }

  setPercentageFeeAboveThreshold(percentageFeeAboveThreshold) {
    this.percentageFeeAboveThreshold = percentageFeeAboveThreshold / 100;
  }
}
